import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SliderModule } from 'primeng/slider';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { NumberSuffixPipe } from 'src/app/core/helpers/number-suffix.pipe';
import { DarkModeToggleModule } from '../components/dark-mode-toggle/dark-mode-toggle.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ArrayTypeComponent } from './formly/array.type';
import { CheckboxTypeComponent } from './formly/checkbox.type';
import { ErrorFieldWrapperComponent } from './formly/error-field-wrapper';
import { FieldWrapperComponent } from './formly/field-wrapper';
import { InputTypeComponent } from './formly/input.type';
import { IntegerTypeComponent } from './formly/integer.type';
import { MinimalFieldWrapperComponent } from './formly/minimal-field-wrapper';
import { NumberTypeComponent } from './formly/number.type';
import { ObjectTypeComponent } from './formly/object.type';
import { TextareaTypeComponent } from './formly/textarea.type';
import { BlockableDivComponent } from './helpers/blockable-div/blockable-div.component';
import { MenuComponent } from './menu/menu.component';
import { MenuitemComponent } from './menu/menuitem.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    MenuitemComponent,
    SidebarComponent,
    TopbarComponent,
    MenuComponent,
    NavbarComponent,
    BlockableDivComponent,

    ObjectTypeComponent,
    ArrayTypeComponent,
    InputTypeComponent,
    IntegerTypeComponent,
    CheckboxTypeComponent,
    FieldWrapperComponent,
    ErrorFieldWrapperComponent,
    MinimalFieldWrapperComponent,
    TextareaTypeComponent,
    NumberTypeComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    StyleClassModule,
    InputTextModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    TooltipModule,
    RippleModule,
    ButtonModule,
    AvatarModule,
    ProgressBarModule,
    DividerModule,
    InputNumberModule,
    SliderModule,
    CheckboxModule,
    InputTextareaModule,
    MenubarModule,
    MenuModule,
    FormsModule,
    DropdownModule,
    DarkModeToggleModule,

    FormlyModule,
    FormlyPrimeNGModule,

    NumberSuffixPipe,
    ContextMenuModule,
    DialogModule,
  ],
  exports: [
    BreadcrumbComponent,
    MenuitemComponent,
    SidebarComponent,
    TopbarComponent,
    MenuComponent,
    BlockableDivComponent,

    ObjectTypeComponent,
    ArrayTypeComponent,
    InputTypeComponent,
    IntegerTypeComponent,
    CheckboxTypeComponent,
    FieldWrapperComponent,
    ErrorFieldWrapperComponent,
    MinimalFieldWrapperComponent,
    TextareaTypeComponent,
    NumberTypeComponent,
  ],
})
export class LayoutModule {}
